import axios from "../plugins/axios.plugin";

class ThirdPartyWebHooksService {
  baseServicePath = "/api/third-party";

  getMyThirdPartyWebhooks(payload) {
    return axios.get(
      `${this.baseServicePath}/webhook/me?business_id=${payload}`
    );
  }

  createThirdPartyWebhook(payLoad) {
    return axios.post(`${this.baseServicePath}/webhook/store`, payLoad);
  }

  deleteThirdPartyWebhook(payLoad) {
    return axios.post(`${this.baseServicePath}/webhook/delete`, payLoad);
  }
}

export const thirdPartyWebHooksService = new ThirdPartyWebHooksService();
